import React from 'react';

import { Link } from 'gatsby';
import { IoIosArrowBack } from 'react-icons/io';

import classnames from 'classnames';

const Back = ({ label, path, color, className }) => {
  return (
    <Link style={{ color }} className={classnames(className, 'back')} to={path || '/'}>
      <IoIosArrowBack className="icon" />
      {label}
    </Link>
  );
};

export default Back;
